import { CSSObject } from '@emotion/react'

export const modalWrapper: CSSObject = {
  alignItems: 'start',
  justifyContent: 'center',
  marginBlockStart: '65px',
}

export const formWrapper: CSSObject = {
  backgroundColor: '#2e3943',
}

export const closeButton: CSSObject = {
  position: 'absolute',
  insetBlockStart: '14px',
  insetInlineEnd: '14px',
}
